import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documentTypes: []
};

export const documentType = createSlice({
  name: 'documentTypeList',
  initialState,
  reducers: {
    setDocumentTypes: (state, action) => {
      state.documentTypes = action?.payload;
    }
  }
});

export const { setDocumentTypes } = documentType?.actions;

export default documentType?.reducer;
